"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import "react-medium-image-zoom/dist/styles.css";
import dynamic from "next/dynamic";
import { getBlurUrl } from "components/Image/utils";
import ImageActions from "./ImageActions";

const Zoom = dynamic(() => import("react-medium-image-zoom"), { ssr: false });

interface ImageGridBigProps {
  images?: { alt: string; src: string; id: number }[];
  title?: string;
  subtitle?: string;
  titleTag: React.ElementType;
  bgColor?: string;
  setBgColor?: (color: string) => void;
  caption?: string;
  showActions?: boolean; // <-- New prop for showing actions
}

const ImageGridBig = ({
  title,
  subtitle,
  bgColor,
  images,
  titleTag = "p",
  setBgColor,
  caption,
  showActions = false // <-- Default value for showActions
}: ImageGridBigProps) => {
  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
    if (setBgColor && bgColor) {
      setBgColor(bgColor);
    }
  }, [bgColor, setBgColor]);

  const TitleTag = titleTag;

  const handleLike = () => {
    // <-- Like handler
  };

  const handleDislike = () => {
    // <-- Dislike handler
  };

  return (
    <>
      <section id="ImageGridBig-83" style={{ backgroundColor: bgColor, width: "100%", height: "100%" }}>
        <div className="tile-container flex h-full flex-col items-center justify-center">
          <div className="text-center">
            <div className="tile-title-container">
              <TitleTag className="tile-main-header">{title}</TitleTag>
              <p className="tile-subtitle">{subtitle}</p>
            </div>
          </div>
          <div id="imageGrid" className={images?.length && images?.length >= 2 ? "grid gap-4 lg:grid-cols-2" : "block"}>
            {images?.map((image, index) => (
              <div key={index} className="relative w-full cursor-pointer justify-center align-middle sm:min-h-[50vh]">
                {/* <-- Common parent div */}
                {/* @ts-ignore */}
                <Zoom onZoomChange={setIsZoomed}>
                  <Image
                    src={image.src}
                    alt={image.alt}
                    layout="responsive"
                    priority
                    blurDataURL={getBlurUrl()}
                    placeholder="blur"
                    width={500}
                    height={500}
                    className="transform rounded-2xl"
                  />
                </Zoom>
                {isZoomed && <div className="caption">{caption}</div>}
                <div className="absolute right-[25px] top-[25px] flex items-center justify-center">
                  {showActions && <ImageActions onLike={handleLike} onDislike={handleDislike} />}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ImageGridBig;
